<!--
 * @Description: 
 * @Author: juanjuanhui
 * @Date: 2023-12-12 20:50:40
 * @LastEditors: likk 1126919170@qq.com
 * @LastEditTime: 2024-09-25 11:18:01
-->
<template>
  <div id="app">
    <keep-alive>
      <router-view v-if="$route.meta.keepAlive"></router-view>
    </keep-alive>
    <router-view v-if="!$route.meta.keepAlive"></router-view>
  </div>
</template>
<script>
  import wx from  'weixin-js-sdk'
  export default {
    data(){
      return {

      }
    },
    created(){
      const { otherAccessToken,
        // wfwAccessToken 
      } = this.$store.state;
      !otherAccessToken && this.$store.dispatch("GetOtherAccessToken");
      // !wfwAccessToken && this.$store.dispatch("GetWFWAccessToken");
      this.configWXShare();
      //判断是否在微信浏览器中打开
      const userAgent = navigator.userAgent.toLowerCase();
      // 判断是否在微信中打开
      if (userAgent.indexOf('micromessenger') !== -1) {
        this.$store.commit('setIsWeixinBrowser', true);
      } else {
        this.$store.commit('setIsWeixinBrowser', false);
      }
    },
    methods: {
      /**
       * @description: 微信分享自定义配置
       * @return {*}
      */   
      async configWXShare(){
        let url = "https://m-ai.nongji360.com/";
        const {signature,appId,nonceStr,timestamp} = await this.$http.common.getWxShareSignature({url})
        wx.config({
            debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参
            appId, // 必填，公众号的唯一标识
            timestamp, // 必填，生成签名的时间戳
            nonceStr, // 必填，生成签名的随机串
            signature, // 必填，签名
            jsApiList:["updateAppMessageShareData","updateTimelineShareData"]
        });
        var shareHref = location.href;
        wx.ready(function () {      //需在用户可能点击分享按钮前就先调用
          wx.updateAppMessageShareData({
              title: "农机万事通", // 分享标题
              desc: '农机万事通（农机AI360），是大田农社·农机360网推出的一款基于AI大模型的行业应用，可以帮助您获得您想要的问题答案，还可以与您一起学习进步。', // 分享描述
              link: shareHref, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
              imgUrl: require("@/assets/images/spark/logo.png"), // 分享图标
              success: function () {
                  // 设置成功
              }
          });
          wx.updateTimelineShareData({
              title: "农机万事通", // 分享标题
              desc: '农机万事通（农机AI360），是大田农社·农机360网推出的一款基于AI大模型的行业应用，可以帮助您获得您想要的问题答案，还可以与您一起学习进步。', // 分享描述
              link: shareHref, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
              imgUrl: require("@/assets/images/spark/logo.png"), // 分享图标
              success: function () {
                  // 设置成功
              }
          });
        });
      }   
    },
  };
</script>
<style lang="scss">
  #app {
    height: 100vh;
  }
</style>
